import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { icon as iconMacro } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/components/Typography';

import { Box, BoxProps } from '../components/Box';
import { Icon } from '../components/Icon';

interface NoResultsProps {
  children?: React.ReactNode;
  sx?: BoxProps;
  title?: React.ReactNode;
  searchTerm?: string;
  compact?: boolean;
  icon?: IconDefinition;
  iconSize?: 'medium' | 'large';
}

export const NoResults: React.FC<NoResultsProps> = ({
  children,
  title,
  searchTerm,
  sx,
  icon = iconMacro({ name: 'search', style: 'regular' }),
  compact = false,
  iconSize = 'medium',
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'common.labels' });
  return (
    <Box sx={{ py: 3, px: 3, textAlign: 'center', ...sx }}>
      {!compact && (
        <Icon color="action" icon={icon} size={iconSize} sx={{ mb: 2 }} />
      )}
      <Typography
        variant="body1"
        gutterBottom
        sx={{
          color: 'text.secondary',
          mb: 2,
        }}
      >
        {title || t('No results')}
      </Typography>
      {searchTerm && !children && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          {t('Searching for "{{searchTerm}}"', { searchTerm })}
        </Typography>
      )}
      {children}
    </Box>
  );
};
